export const HBO_NODE_CODES = ['pandg_hbo', 'pandg_hbov2'];

const normalize = value => (value || '').toLowerCase();

export const isHboNodeCode = code => HBO_NODE_CODES.includes(normalize(code));

export const isHboProviderCode = code => normalize(code).startsWith('hbo');


export const isHboLiveref = liveref => normalize(liveref).includes('hbo');

// Punto unico para decidir si un contenido/nodo es de HBO sin importar su tipo (nodo de
// navegacion, vcard o canal en vivo) — ver TBRFRE-1790 7.2.1: la interceptacion debe
// depender del provider_code/nodo real, nunca de un tipo de contenido especial.
export const isHboContentInfo = contentInfo => {
  const providerCode = contentInfo?.proveedor_code || contentInfo?.provider?.code;

  return (
    isHboProviderCode(providerCode) ||
    isHboNodeCode(contentInfo?.section) ||
    isHboNodeCode(contentInfo?.code)
  );
};
